<template>
  <a
    class="n-button"
    :class="[size,type,disabled?'disabled':'', onlyIcon ? 'only-icon' : '']"
    
    @click.prevent="handleClick"
  >
    <n-icon :icon="icon" :fill="iconFill" v-if="icon.length > 0"><span class="slot" ><slot></slot></span></n-icon>
    <span class="slot" v-else><slot></slot></span>
  </a>
</template>

<script>
export default {
  data() {
    return {
      onlyIcon: false,
    };
  },
  created() {
    if (this.$slots.default === undefined) {
      this.onlyIcon = true;
    }
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
  props: {
    iconFill:{
      type:Boolean,
      default:false,
    },
    disabled:{
      type:Boolean,
      default:false,
    },
    icon: {
      default: "",
      type: String,
    },
    type: {
      default: "primary",
      type: String,
    },
    plain: {
      default: false,
      type: Boolean,
    },
    size: {
      default: "normal",
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.n-button {
  font-size: 22px;
  user-select: none;
  cursor: pointer;
  outline: none;
  border-radius: 4px;
  padding: 0px 16px;
  background-color: #fff;
  display: inline-block;
  transition: all 0.2s linear;
  height: 52px;
  line-height: 52px;
  min-width: 140px;
  text-align: center;
  .n-icon {
    vertical-align: 0.2em;
    margin-right: 8px;
  }
}
.only-icon {
  background-color: transparent !important;
  color: #666 !important;
}
.default {
  background-color: transparent;
  border: 1px solid $primaryColor;
  border-radius: 4px;
  box-shadow: 0 2px 0 rgb(0 0 0 / 8%);
  color: $primaryColor;
  &:hover {
    color: #fff;
    background-color: rgba($primaryColor, $alpha: 0.6);
    border-color: rgba($primaryColor, $alpha: 0.6);
  }
}
.primary {
  background-color: $primaryColor;
  color: #fff;
  box-shadow: 0 2px 0 rgb(0 0 0 / 8%);
  &:hover {
    background-color: rgba($primaryColor, $alpha: 0.76);
    border-color: rgba($primaryColor, $alpha: 0.76);
  }
}
.plain {
  background-color: #fff !important;
  color: $primaryColor !important;
}
.secondary {
  color: #555555 !important;
  &:hover {
    color: $primaryColor !important;
  }
}
.normal {
  height: 52px;
}
.small {
}
.medium {
  height: 40px;
  line-height:40px;
  font-size: 14px;
}
.disabled {
  pointer-events: none;
  cursor: not-allowed;
  background-color:#ededed;
  border:none;
}
</style>
